import { BasePageTrackingService } from '../BasePageTrackingService';

export class DashboardTrackingService extends BasePageTrackingService {}
